import { SignedIn, SignedOut } from "@clerk/clerk-react";
import AuthenticatedLayout from "@/pages/layouts/AuthenticatedLayout";
import UnauthenticatedLayout from "@/pages/layouts/UnauthenticatedLayout";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export default function RootLayout() {
  const { mobileToken } = useSelector((state: RootState) => state.session);

  return (
    <div className="flex flex-col">
      {mobileToken ? (
        <AuthenticatedLayout />
      ) : (
        <>
          <SignedIn>
            <AuthenticatedLayout />
          </SignedIn>
          <SignedOut>
            <UnauthenticatedLayout />
          </SignedOut>
        </>
      )}

      {/* <main className="flex-grow">
        <Toaster />
        <Outlet />
      </main> */}
    </div>
  );
}
